import React from "react";
import PageLayout from "../../components/PageLayout/PageLayout";
import PostSection from "./Sections/PostSection";

export default function NewsPage(props) {
  const { configuration } = props;

  return (
    <PageLayout configuration={configuration} title="Nachrichten">
      <PostSection />
    </PageLayout>
  );
}
